var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "lbs-viewer-slide-tray",
    attrs: { id: _vm.accordionDivId }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/slide-tray-workflow/SlideTray.vue?vue&type=template&id=eae1202e&scoped=true&
// module id = 333
// module chunks = 0